import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetProfessionalProfileParams } from '../types/IGetProfessionalProfileParams';
import { IProfessionalProfileApi } from '../types/IProfessionalProfile';

export const GetProfessionalProfileClient = {
  getProfessionalProfile: async ({
    professionalId,
    officeId,
    jobProfession,
  }: IGetProfessionalProfileParams): Promise<IProfessionalProfileApi> => {
    const headers = await getAuthHeaders();

    const response = await tempMeeApi.get<IProfessionalProfileApi>(
      `/professionals/${professionalId}/profile`,
      {
        headers: { ...headers, 'x-office': officeId ?? undefined },
        params: { jobProfession: jobProfession ?? undefined },
      },
    );

    return response.data;
  },
};
